// Dispatch
export const convertOfflineAction = (offlineWorkorder, onlineWorkorder) => dispatch =>
  dispatch({
    type:    WORKORDER_CONVERT_OFFLINE.ACTION,
    payload: { offlineWorkorder, onlineWorkorder }
  })

// Reducer response
export const WORKORDER_CONVERT_OFFLINE = {
  ACTION: 'WORKORDER_CONVERT_OFFLINE',

  call: ({ state, offlineWorkorder, onlineWorkorder }) => {
    const converted = {
      ...offlineWorkorder,
      id: onlineWorkorder.id,
      loading: false,
      synced: false,
      creating: false,
      extra_field_answers: offlineWorkorder.extra_field_answers.map(answer => {
        const onlineAnswer = onlineWorkorder.extra_field_answers.find(a => a.extra_field_id == answer.extra_field_id)
        if (onlineAnswer) {
          return { ...answer, id: onlineAnswer.id }
        } else {
          return answer
        }
      })
    }

    const swap = collection => collection.map(item => item.id != offlineWorkorder.id ? item : converted)

    return {
      ...state,
      items:             swap(state.items),
      stored_workorders: swap(state.stored_workorders)
    }
  }
}
